import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { Currency, P } from '../../components/';

import { ORDERTYPE_STRING_MAP } from '../constants';

const OrderStatusCard = ({ order, handleClick }) => {
  const {
    id,
    sapOrderNumber,
    departmentName,
    orderType,
    purchaseOrderRef,
    purchaseMethod,
    orderNeTotal,
    orderSubmittedbyFullname,
    createTimestamp,
    orderStatus,
    currencyCode
  } = order;
  const handleCardClick = () => handleClick(id);
  return (
    <div className='orderStatus__card bg-white pt5-sm pb4-sm prl4-sm border-bottom' onClick={handleCardClick}>
      <div className='mb4-sm'>{sapOrderNumber}</div>
      <div className='text-color-secondary'>
        <P>
          <TranslatedCopy id='global.department' />
          {`: ${departmentName}`}
        </P>
        <P>
          <TranslatedCopy id='global.orderType' />
          {': '}
          <span>{ORDERTYPE_STRING_MAP[orderType]}</span>
        </P>
        <P>
          <TranslatedCopy id='orderstatus.poNumber' />
          {`: ${purchaseOrderRef}`}
        </P>
        <P>
          <TranslatedCopy id='global.paymentMethod' />
          {`: ${purchaseMethod}`}
        </P>
        {orderNeTotal && (
          <P>
            <TranslatedCopy id='orderstatus.netTotal' />
            {': '}
            <Currency value={orderNeTotal} type={currencyCode} />
          </P>
        )}
        {orderSubmittedbyFullname && (
          <P>
            <TranslatedCopy id='global.submittedBy' />
            {`: ${orderSubmittedbyFullname}`}
          </P>
        )}
        <P>
          <TranslatedCopy id='orderstatus.orderSubmittedDate' />
          {': '}
          <FormattedDate value={createTimestamp} />
        </P>
        <P>
          <TranslatedCopy id='orderstatus.orderStatus' />
          {`: ${orderStatus}`}
        </P>
      </div>
    </div>
  );
};
OrderStatusCard.defaultProps = {
  order: null
};

OrderStatusCard.propTypes = {
  order: PropTypes.any,
  handleClick: PropTypes.func.isRequired
};

export default OrderStatusCard;
